import { render, staticRenderFns } from "./ReadingDeleteDialog.vue?vue&type=template&id=34a0187d&scoped=true"
import script from "./ReadingDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./ReadingDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./ReadingDeleteDialog.vue?vue&type=style&index=0&id=34a0187d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a0187d",
  null
  
)

export default component.exports